import { createApi } from '@reduxjs/toolkit/query/react'
import { CREATE_DESIGNATION, LIST_DESIGNATION, REMOVE_DESIGNATION, UPDATE_DESIGNATION, VIEW_DESIGNATION } from "config/apiPaths"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const designationsApi = createApi({
  reducerPath: 'designationsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: "/designation",
  }),
  tagTypes: ["Designations"],
  endpoints: (builder) => ({
    // get designations list
    getDesignationsList: builder.query({
      query: ({ search = "", status = "", page = 1, limit = 10, sort = { column: "title", direction: "ASC" } }) => ({
        method: "PATCH",
        url: LIST_DESIGNATION,
        data: {
          search,
          status,
          page,
          limit,
          sort,
        },
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["Designations", "DesignationsLookup"]
    }),

    // get designation data
    getDesignationData: builder.query({
      query: (id) => ({
        method: "GET",
        url: `${VIEW_DESIGNATION}/${id}`
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["Designations"]
    }),

    // create designation
    createDesignation: builder.mutation({
      query: (data) => ({
        method: "POST",
        url: CREATE_DESIGNATION,
        data
      }),
      invalidatesTags: ["Designations"]
    }),

    // update designation
    updateDesignation: builder.mutation({
      query: (data) => ({
        method: "PUT",
        url: `${UPDATE_DESIGNATION}/${data.id}`,
        data: data.payload
      }),
      invalidatesTags: ["Designations"]
    }),

    // delete designation
    deleteDesignation: builder.mutation({
      query: (id) => ({
        method: "DELETE",
        url: `${REMOVE_DESIGNATION}/${id}`
      }),
      invalidatesTags: ["Designations"]
    }),

    designationLookup: builder.query({
      query: (id) => ({
        method: "GET",
        url: "/"
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["DesignationsLookup"]
    }),
  }),
})

export const {
  useLazyGetDesignationsListQuery,
  useGetDesignationsListQuery,
  useCreateDesignationMutation,
  useGetDesignationDataQuery,
  useUpdateDesignationMutation,
  useDeleteDesignationMutation,
  useDesignationLookupQuery,
} = designationsApi;